import React, { useEffect } from "react";

const MessageList = ({
  messages,
  userType,
  search,
  showSearch,
  editingId,
  setEditingId,
  editedText,
  setEditedText,
  updateMessages,
  scrollableRef,
  bottomRef,
  setHasUnread,
  dropdownOpenId,
  setDropdownOpenId,
}) => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (bottomRef.current) {
        const atBottom =
          scrollableRef.current.scrollHeight -
            scrollableRef.current.scrollTop -
            scrollableRef.current.clientHeight <
          100;
        if (atBottom) {
          scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
        } else {
          setHasUnread(true);
        }
      }
    });

    if (scrollableRef.current) {
      observer.observe(scrollableRef.current, {
        childList: true,
        subtree: true,
      });
    }
    return () => observer.disconnect();
  }, [messages]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !e.target.closest(".dropdown-menu") &&
        !e.target.closest(".dropdown-toggle")
      ) {
        setDropdownOpenId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const filtered = showSearch
    ? messages.filter((m) =>
        m.text?.toLowerCase().includes(search.toLowerCase())
      )
    : [...messages.filter((m) => m.pinned), ...messages.filter((m) => !m.pinned)];

  const handleDelete = (id) => {
    updateMessages(messages.filter((msg) => msg.id !== id));
  };

  const handlePin = (id) => {
    const updated = messages.map((msg) =>
      msg.id === id ? { ...msg, pinned: !msg.pinned } : msg
    );
    updateMessages(updated);
  };

  const renderMessage = (msg) => {
    const isOwn = msg.sender === userType;
    const isDropdownOpen = dropdownOpenId === msg.id;

    return (
      <div
        key={msg.id}
        className={`relative group max-w-[80%] px-4 py-2 rounded-lg text-sm shadow-md whitespace-pre-line break-words ${
          isOwn ? "bg-blue-100 self-end" : "bg-gray-100 self-start"
        } ${msg.pinned ? "border-l-4 border-yellow-500 sticky top-2 z-20 bg-yellow-100" : ""}`}
      >
        <div className="absolute top-1 right-1">
          <button
            className="text-gray-600 hover:text-black text-lg dropdown-toggle"
            onClick={() => setDropdownOpenId(isDropdownOpen ? null : msg.id)}
          >
            ⋮
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-300 rounded-md shadow-xl z-50 dropdown-menu text-sm">
              <button
                className="block w-full px-4 py-2 hover:bg-gray-100 text-left"
                onClick={() => handleDelete(msg.id)}
              >
                🗑️ Delete
              </button>
              <button
                className="block w-full px-4 py-2 hover:bg-gray-100 text-left"
                onClick={() => handlePin(msg.id)}
              >
                {msg.pinned ? "📌 Unpin" : "📌 Pin"}
              </button>
            </div>
          )}
        </div>

        {msg.type === "pdf" ? (
          <a
            href={msg.media}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            📄 Open PDF
          </a>
        ) : msg.type === "voice" ? (
          <audio controls src={msg.media} className="mt-1" />
        ) : msg.media ? (
          <a
            href={msg.media}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            📎 Open File
          </a>
        ) : (
          msg.text
        )}

        <div className="text-gray-400 text-xs mt-1 text-right">{msg.time}</div>
      </div>
    );
  };

  return (
    <div
      ref={scrollableRef}
      className="flex-1 flex flex-col overflow-y-auto p-4 space-y-3"
    >
      {filtered.map(renderMessage)}
      <div ref={bottomRef} />
    </div>
  );
};

export default MessageList;
